import { Stack, Typography } from '@mui/material';
import { useEffect, useState } from 'react';
import { Dictionary } from 'Dictionary';
import { DICTIONARY } from 'Enum';
import { useDictionary, useIsDesktop } from 'Hooks';
import { OTPCode } from './OTPCode';
import { validationCodeLength } from '..';

interface IValidation {
  isValidated: boolean | null;
  setIsValidated: Function;
  validationHandler: Function;
  isCodeSentAgain: boolean;
  isBlocked: boolean;
  code: (string | null)[];
  setCode: React.Dispatch<React.SetStateAction<(string | null)[]>>;
}

export const Validation = ({
  validationHandler,
  isValidated,
  setIsValidated,
  isCodeSentAgain,
  isBlocked,
  code,
  setCode,
}: IValidation) => {
  const isDesktop = useIsDesktop();
  const dictionary = useDictionary(
    Dictionary,
    DICTIONARY.OTP_Login
  ).phoneEmailValidation;

  useEffect(() => {
    if (isCodeSentAgain) setCode(Array(validationCodeLength).fill(null));
  }, [isCodeSentAgain]);

  useEffect(() => {
    if (code.includes(null)) setIsValidated(null);
  }, [code, setIsValidated]);

  return (
    <>
      <Stack
        direction='row-reverse'
        justifyContent='center'
        gap='15px'
        mb='26px'
      >
        <OTPCode
          isCodeSentAgain={isCodeSentAgain}
          setCode={setCode}
          isValidated={isValidated}
          isBlocked={isBlocked}
          validationHandler={validationHandler}
        />
      </Stack>
      {isValidated === false && (
        <Typography
          id='wrong-otp-code'
          sx={{
            mb: '16px',
            fontWeight: isDesktop ? 600 : 700,
            fontSize: isDesktop ? '18px' : '16px',
            fontFamily: 'inherit',
            lineHeight: isDesktop ? '22px' : '24px',
            color: 'error.main',
          }}
          role='alert'
        >
          {isBlocked ? dictionary.blocked : dictionary.wrongCode}
        </Typography>
      )}
    </>
  );
};
